import { FreightService } from '@prisma/client';
import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';

type UseQuote = [TrpcOutputs['getQuotesByRequestId'] | undefined, boolean, string | undefined];

export const useQuotes = (requestId?: number, freightServices?: FreightService[]): UseQuote => {
  const initQuery = trpc.getQuotesByRequestId.useQuery({ requestId, freightServices });
  const [error, setError] = useState<string>();
  const [data, setData] = useState<TrpcOutputs['getQuotesByRequestId'] | undefined>([]);

  useEffect(() => {
    if (initQuery.data) setData(initQuery.data);
  }, [initQuery.data]);

  useEffect(() => {
    if (initQuery.error) setError(initQuery.error.message);
  }, [initQuery.error]);

  trpc.onQuoteCreated.useSubscription({ requestId } as any, {
    onData: (newData: any) => {
      if (freightServices && !freightServices.includes(newData.freight_service as FreightService)) return;
      setData((prevData: any) => {
        return [newData, ...(prevData ?? [])];
      });
    },
    onError: (err: any) => {
      console.log('onQuoteCreated error: ', err);
      setError(err?.message);
    },
  });

  trpc.onQuoteUpdated.useSubscription({ requestId } as any, {
    onData: (newData: any) => {
      if (freightServices && !freightServices.includes(newData.freight_service as FreightService)) return;
      setData((prevData: any) => {
        return prevData.map((quote: any) => {
          if (quote.id === newData.id) return newData;
          return quote;
        });
      });
    },
    onError: (err: any) => {
      console.log('onQuoteUpdated error: ', err);
      setError(err?.message);
    },
  });

  trpc.onQuoteDeleted.useSubscription({ requestId } as any, {
    onData: (deletedQuoteId: number) => {
      setData((prevData: any[]) => {
        const nextData = prevData.filter((quote) => quote.id !== deletedQuoteId);
        return nextData;
      });
    },
    onError: (err: any) => {
      console.log('onQuoteDeleted error: ', err);
      setError(err?.message);
    },
  });

  const isLoading = Boolean(initQuery.isLoading);
  return [data, isLoading, error];
};
